<template>
  <span v-if="origin" class="message-origin" :class="{ 'message-origin-detail': details }" aria-label="消息来源">
    <span v-if="origin.projectName"><BiosIcon name="folder" :size="13" aria-hidden="true" />项目：{{ origin.projectName }}</span>
    <span v-if="origin.sessionTitle"><BiosIcon name="message-circle" :size="13" aria-hidden="true" />会话：{{ origin.sessionTitle }}</span>
    <span v-if="details && origin.subject" class="message-origin-subject">事项：{{ origin.subject }}</span>
  </span>
</template>
<script setup>
import { computed } from 'vue'
import BiosIcon from '@/components/BiosIcon.vue'
const props = defineProps({ message: { type: Object, required: true }, details: Boolean })
const origin = computed(() => {
  const value = props.message.content?.context
  if (!value || ![value.projectName, value.sessionTitle].some(text => typeof text === 'string' && text.trim())) return null
  return Object.fromEntries(['projectName', 'sessionTitle', 'subject'].map(key => [key, typeof value[key] === 'string' ? value[key] : '']))
})
</script>
